export default {
    "name": "EvaluateSelectQuery",
    "kind": "HoudiniQuery",
    "hash": "e1aa81c3e0c4792d38ef550c5839090a4910a7d9ceb96990c0826bf0e0d60975",

    "raw": `query EvaluateSelectQuery($query: String!) {
  evaluateSelectQuery(query: $query) {
    result
    success
    message
  }
}
`,

    "rootType": "Query",
    "stripVariables": [],

    "selection": {
        "fields": {
            "evaluateSelectQuery": {
                "type": "QueryEvaluation",
                "keyRaw": "evaluateSelectQuery(query: $query)",

                "selection": {
                    "fields": {
                        "result": {
                            "type": "String",
                            "keyRaw": "result",
                            "nullable": true,
                            "visible": true
                        },

                        "success": {
                            "type": "Boolean",
                            "keyRaw": "success",
                            "visible": true
                        },

                        "message": {
                            "type": "String",
                            "keyRaw": "message",
                            "nullable": true,
                            "visible": true
                        }
                    }
                },

                "visible": true
            }
        }
    },

    "pluginData": {
        "houdini-svelte": {
            "isManualLoad": true
        }
    },

    "input": {
        "fields": {
            "query": "String"
        },

        "types": {},
        "defaults": {},
        "runtimeScalars": {}
    },

    "policy": "NetworkOnly",
    "partial": false
};

"HoudiniHash=80ad90b360b7c06dd12a0619de70880bed45e677c8826b304abffcd5688acd52";